import { render, staticRenderFns } from "./AvatarGroup.vue?vue&type=template&id=7ef77780&scoped=true"
import script from "./AvatarGroup.vue?vue&type=script&lang=js"
export * from "./AvatarGroup.vue?vue&type=script&lang=js"
import style0 from "./AvatarGroup.vue?vue&type=style&index=0&id=7ef77780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef77780",
  null
  
)

export default component.exports